(function () {
  function modeOf(root) {
    var checked = root.querySelector('.hm-pau__radio:checked');
    return checked ? checked.getAttribute('data-mode') : '1';
  }

  function moveThumb(root) {
    var tabs = root.querySelector('.hm-pau__tabs');
    var thumb = root.querySelector('.hm-pau__thumb');
    var on = root.querySelector('.hm-pau__tab[aria-selected="true"]');
    if (!tabs || !thumb || !on) return;
    thumb.hidden = false;
    var box = tabs.getBoundingClientRect();
    var pill = on.getBoundingClientRect();
    thumb.style.height = pill.height + 'px';
    thumb.style.width = pill.width + 'px';
    thumb.style.transform = 'translate(' + (pill.left - box.left) + 'px, ' + (pill.top - box.top) + 'px)';
  }

  function sync(root) {
    var mode = modeOf(root);
    var checked = root.querySelector('.hm-pau__radio:checked');
    root.querySelectorAll('.hm-pau__tab').forEach(function (tab) {
      var on = checked && tab.getAttribute('for') === checked.id;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    root.querySelectorAll('.hm-pau__board').forEach(function (board) {
      var on = board.getAttribute('data-mode') === mode;
      board.classList.toggle('is-on', on);
      board.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in board) board.inert = !on;
    });
    moveThumb(root);
  }

  function bind(root) {
    if (!root || root.__hmPau) return;
    root.__hmPau = true;
    root.classList.add('hm-pau--js');
    sync(root);
    requestAnimationFrame(function () {
      moveThumb(root);
    });
    root.addEventListener('change', function (event) {
      if (event.target.classList.contains('hm-pau__radio')) sync(root);
    });
    root.addEventListener('keydown', function (event) {
      if (!event.target.classList.contains('hm-pau__tab')) return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.hm-pau__tab'));
      var i = tabs.indexOf(event.target);
      if (i < 0) return;
      var next = i;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
      else return;
      event.preventDefault();
      var radio = document.getElementById(tabs[next].getAttribute('for'));
      if (!radio) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      tabs[next].focus();
    });
    window.addEventListener('resize', function () {
      moveThumb(root);
    });
  }

  function init() {
    document.querySelectorAll('.hm-pau').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) event.target.querySelectorAll('.hm-pau').forEach(bind);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var board = event.target.closest('.hm-pau__board');
    var root = event.target.closest('.hm-pau');
    if (!board || !root) return;
    var assigned = board.getAttribute('data-mode');
    var radio = root.querySelector('.hm-pau__radio[data-mode="' + assigned + '"]');
    if (!radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
